import { AsyncStorageController } from "@ciaopeople/cp-shatsu/Storage";
import { ClientSdkPublicInterface } from "../../sdk/ClientSdkPublicInterface.js";
import { NamedChainedCTAEvaluator } from "./ChainedCTAEvaluator.js";
import { evaluateLoginProposalReviewed } from "./evaluations/LoginProposalReviewed.js";
import { personalDataEvaluation } from "./evaluations/PersonalDataEvaluations.js";
import { inAppActionEvaluation } from "./evaluations/NativeAppActionsProposal.js";
import { evaluateMaybeInteractiveAutologinProposal } from "./evaluations/MaybeInteractiveAutologinProposal.js";
import { ThrottleStoreAsyncStorageFactory } from "./throttle/ThrottleStoreAsyncStorageFactory.js";
import { TimeThrottleClause } from "./throttle/TimeThrottleClause.js";
import { throttleNamedEvaluation } from "./ThrottledChainableEvaluation.js";
import { evaluateSubscriptionProposal } from "./evaluations/SubscriptionProposal.js";
import { devModeHelper } from "../../utils/DevelopmentModeHelper.js";
import { EvaluationName } from "./EvaluatedActionExecutor.js";
import { StatsCollector } from "../../stats/StatsCollector.js";

function hours(numHours: number): number {
    return numHours * 3600;
}



function days(numDays: number): number {
    return hours(24) * numDays;
}



export class BasicCTALogicImpl extends NamedChainedCTAEvaluator {


    

    constructor(
        sdk: ClientSdkPublicInterface,
        asyncStorage: AsyncStorageController<string>,
        stats: StatsCollector
    ) {
        const factory = new ThrottleStoreAsyncStorageFactory(asyncStorage);

        const maybeInteractiveAutoLoginThrottleClause = new TimeThrottleClause(
            devModeHelper.isDevelopmentMode() ? 1 : days(1),
            factory.getThrottleStore("_th_mi_autologin")
        );
        const loginThrottleClause = new TimeThrottleClause(
            devModeHelper.isDevelopmentMode() ? 1 : days(1),
            factory.getThrottleStore("_th_login")
        );
        const inAppActionThrottle = new TimeThrottleClause(
            devModeHelper.isDevelopmentMode() ? 1 : days(1),
            factory.getThrottleStore("_th_inapp")
        );
        const personalDataThrottle = new TimeThrottleClause(
            devModeHelper.isDevelopmentMode() ? 1 : days(7),
            factory.getThrottleStore("_th_perdata")
        );
        const subscriptionThrottle = new TimeThrottleClause(
            devModeHelper.isDevelopmentMode() ? 1 : hours(12),
            factory.getThrottleStore("_th_subscr")
        );

        super(sdk, [
            throttleNamedEvaluation(EvaluationName.MAYBE_INTERACTIVE_AUTOLOGIN_EVALUATION, maybeInteractiveAutoLoginThrottleClause, null, (s, l) => evaluateMaybeInteractiveAutologinProposal(s, l)), 
            throttleNamedEvaluation(EvaluationName.LOGIN_EVALUATION, loginThrottleClause, null, (s, l) => evaluateLoginProposalReviewed(s, l)), 
            throttleNamedEvaluation(EvaluationName.APP_DOWNLOAD_EVALUATION, inAppActionThrottle, null, (s, l) => inAppActionEvaluation(s, l)), 
            throttleNamedEvaluation(EvaluationName.PERSONAL_DATA_EVALUATION, personalDataThrottle, null, (s, l) => personalDataEvaluation(s, l)),
            throttleNamedEvaluation(EvaluationName.SUBSCRIPTION_EVALUATION, subscriptionThrottle, null, (s, l) => evaluateSubscriptionProposal(s, l)),
        ], stats);
    }

  
}

export class BasicCTALogicImplPromiseLocked extends BasicCTALogicImpl {
    constructor(
        sdk: ClientSdkPublicInterface,
        asyncStorage: AsyncStorageController<string>,
        stats: StatsCollector,
        private lockPromise: Promise<void>
    ) {
        super(sdk, asyncStorage, stats);
    }

    public execCTA(): Promise<void> {
        return this.lockPromise.then(() => {
            return super.execCTA();
        })
    }
}